var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.6035L12.548 16.7402C12.688 16.8244 12.8431 16.869 13.0008 16.8702C13.1584 16.8714 13.314 16.8292 13.455 16.7472L16.447 15.0071C16.613 14.9105 16.7527 14.7621 16.8504 14.5785C16.9481 14.3948 16.9999 14.1832 17 13.9672V10.7522C16.9999 10.5362 16.9481 10.3246 16.8504 10.1409C16.7527 9.95727 16.613 9.80887 16.447 9.71233L13 7.70703L9.54 9.79143C9.37725 9.8895 9.24081 10.0377 9.14558 10.2199C9.05034 10.402 8.99999 10.6111 9 10.8243V14.6035Z",
    stroke: "black",
    strokeWidth: 0.952381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54 14.9328L4.54798 16.745C4.68799 16.8292 4.84313 16.8738 5.00076 16.875C5.15838 16.8762 5.31402 16.834 5.45497 16.752L8.99995 14.6908V10.757C8.99985 10.541 8.94807 10.3294 8.8504 10.1457C8.75273 9.96207 8.61303 9.81367 8.44695 9.71713L4.99998 7.71183L1.54 9.79623C1.37725 9.8943 1.24081 10.0425 1.14558 10.2247C1.05035 10.4068 0.999985 10.6159 1 10.8291V13.8999C0.999985 14.1131 1.05035 14.3222 1.14558 14.5043C1.24081 14.6865 1.37725 14.8347 1.54 14.9328ZM4.99998 7.62925L8.54795 9.76599C8.68796 9.85022 8.84311 9.89475 9.00073 9.89597C9.15836 9.89718 9.31399 9.85503 9.45495 9.77297L12.9999 7.71183V3.778C12.9998 3.56204 12.948 3.35038 12.8504 3.16672C12.7527 2.98306 12.613 2.83466 12.4469 2.73813L9.45495 0.998026C9.31399 0.915959 9.15836 0.873813 9.00073 0.875025C8.84311 0.876238 8.68796 0.920776 8.54795 1.00501L5.53997 2.81722C5.37723 2.91529 5.24079 3.0635 5.14555 3.24566C5.05032 3.42782 4.99996 3.63692 4.99998 3.85011V7.62925Z",
    stroke: "black",
    strokeWidth: 0.952381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34666 3.25749L8.55364 5.12205C8.69244 5.20272 8.84547 5.24472 9.00063 5.24472C9.1558 5.24472 9.30883 5.20272 9.44763 5.12205L12.6206 3.27726M7.29964 2.06641L11.0006 4.21943M11.2996 9.04541L15.0006 11.1984M3.29967 9.04541L7.00065 11.1984M9.34663 10.2365L12.5536 12.1011C12.6924 12.1817 12.8454 12.2237 13.0006 12.2237C13.1558 12.2237 13.3088 12.1817 13.4476 12.1011L16.6196 10.2563M1.34668 10.2365L4.55366 12.1011C4.69246 12.1817 4.84549 12.2237 5.00066 12.2237C5.15582 12.2237 5.30886 12.1817 5.44765 12.1011L8.61964 10.2563M9.00063 5.3826V10.0353M13.0006 12.3616V16.4327M5.00066 12.3616V16.4327",
    stroke: "black",
    strokeWidth: 0.952381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsIcon);
export default __webpack_public_path__ + "static/media/fsIcon.9a32c751c2f238581c43f81623230551.svg";
export { ForwardRef as ReactComponent };